export default __webpack_public_path__ + "static/media/finance.fe5fa264.png";